import { LocaleAnchor } from '@/i18n/router';
import { Localize } from '@/i18n/Localize';
import { sharedPortuguese } from '@/i18n/shared';
import React, { useEffect, useState } from 'react';
import { useLocale } from '@/i18n/LocaleProvider';
import { useLocation } from 'react-router-dom';
import { counterpartOrigin, englishPath } from '@/i18n/locale';

import { Link } from '@/i18n/router';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';
import SEO from '@/components/SEO';
import { Home, Search, ArrowLeft } from 'lucide-react';

const NotFound = () => {
  const { locale } = useLocale();
  const location = useLocation();
  // Nginx serves one static 404 document for unknown URLs. Use its deterministic
  // link during hydration, then recover the requested URL on the English site in the browser.
  const [englishUrl, setEnglishUrl] = useState('/404');
  useEffect(() => {
    setEnglishUrl(counterpartOrigin(window.location, 'en') + englishPath(location.pathname) + location.search + location.hash);
  }, [location.pathname, location.search, location.hash]);
  return <Localize messages={sharedPortuguese}>{(
    <div className="min-h-screen flex flex-col">
      <SEO 
        noindex
        title="Page Not Found | GizmoData"
        description="The page you're looking for could not be found."
        url="https://gizmodata.com/404"
      />
      <Navbar />
      <main className="flex-grow flex items-center justify-center px-4">
        <div className="text-center max-w-2xl">
          <div className="mb-8">
            <h1 className="text-8xl font-bold text-primary mb-4">
              404
            </h1>
            <h2 className="text-3xl font-bold mb-4">
              Page Not Found
            </h2>
            <p className="text-lg text-muted-foreground mb-8">
              The page you're looking for doesn't exist or has been moved.
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/">
              <Button size="lg" className="gap-2">
                <Home className="h-4 w-4" />
                Go to Homepage
              </Button>
            </Link>
            <Button 
              size="lg" 
              variant="outline" 
              className="gap-2"
              onClick={() => window.history.back()}
            >
              <ArrowLeft className="h-4 w-4" />
              Go Back
            </Button>
          </div>

          {locale === 'pt-BR' && <p className="mt-6">Esta página não está disponível em português. <LocaleAnchor className="underline" href={englishUrl} hrefLang="en">Ver versão em inglês</LocaleAnchor></p>}
          <div className="mt-12 pt-12 border-t">
            <h3 className="text-lg font-semibold mb-4">Popular Pages</h3>
            <div className="flex flex-wrap gap-3 justify-center">
              <Link to="/hardcharger">
                <Button variant="ghost" size="sm">Hardcharger</Button>
              </Link>
              <Link to="/gizmoedge">
                <Button variant="ghost" size="sm">GizmoEdge</Button>
              </Link>
              <Link to="/about">
                <Button variant="ghost" size="sm">About Us</Button>
              </Link>
              <Link to="/blog">
                <Button variant="ghost" size="sm">Blog</Button>
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )}</Localize>;
};

export default NotFound;
